import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { IOptionsResponse } from '../../../common/common.types'
import { setGuarantorsAgeOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'

export function* getGuarantorsAgeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getGuarantorsAgeOptions])
    const { entity } = response
    yield put(setGuarantorsAgeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getGuarantorsAgeOptions() error: ${e}`))
  }
}

export function* getGuarantorsAgeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getGuarantorsAgeOptions)
}
